import { useSearchParams } from 'react-router-dom';
import { CollapsibleGroup } from './CollapsibleGroup';
import type { IModuleMenuGroupsProps } from './IModuleMenuGroupsProps';
import { MenuEntryLink } from './MenuEntryLink';
import { moduleGroupOpen, moduleMenuActiveKey } from './moduleMenuOf';
import { tableEntryKeyOf } from './moduleSections';
import { useWorkspaceParams } from '@platform/hooks/useWorkspaceParams';

/**
 * Власне меню модуля замість розділів за типами записів (прототип v4 mnGroups «Аналітичних інструментів» і «Конструктора законопроєктів»):
 * розгортні групи з пунктами різних таблиць модуля, кожен — з живим лічильником; пункт відкриває список свого типу в поданні «Таблиця» з
 * пунктом меню типу (фільтр, чип). Група типово розгорнута, коли вона не згорнута в метаданих, має активний пункт або таблицю поточного типу;
 * вибір користувача пам'ятається для модуля.
 */
export function ModuleMenuGroups({ ws, moduleKey, definition, groups, current, openState }: IModuleMenuGroupsProps) {
  const route = useWorkspaceParams();
  const [params] = useSearchParams();
  const routeType = definition.recordTypes.find((r) => r.key === route.rt);
  const active = moduleMenuActiveKey(groups, route, params.get('item'), routeType?.views.default, routeType ? tableEntryKeyOf(routeType) : undefined);
  return (
    <>
      {groups.map((g) => {
        const fallback = moduleGroupOpen(g, active, current);
        return (
          <CollapsibleGroup key={g.id} title={g.title} open={openState.isOpen(g.id, fallback)} onToggle={() => openState.toggle(g.id, fallback)}>
            {g.items.map((i) => <MenuEntryLink key={i.key} ws={ws} moduleKey={moduleKey} rtKey={i.rtKey} entry={i.entry} active={i.key === active} />)}
          </CollapsibleGroup>
        );
      })}
    </>
  );
}
